import { TypeGroupIds } from "../modules/shared/constants/category-groupid.constants";

export enum AddressTypeName {
    BILLING = "Billing",
    SHIPPING = "Shipping"
}

export enum AddressTypeId {
    BILLING = 38,
    SHIPPING = 39,
    OTHER = 40
}

export enum AccountGroupId {
    ID = TypeGroupIds.AccountTypeAccountAPI
};

export enum AccountViewTabIndex {
   OVERVIEW,
   ACTIVITY,
   CONTACT,
   DOCUMENT,
   TASK,
   ACCESS
};
